import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card, CardBody, Col, Container, Row, Modal, ModalHeader, ModalBody,
  Label, FormFeedback, UncontrolledTooltip, Input, Form, Button, Badge,
  Nav, NavItem, NavLink, TabContent, TabPane, Table, Progress
} from "reactstrap";
import classnames from "classnames";
import * as Yup from "yup";
import { useFormik } from "formik";
import jsPDF from "jspdf";
import "jspdf-autotable";

// Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";

import {
  getUsers as onGetUsers,
  addUser as onAddUser,
  updateUser as onUpdateUser,
  deleteUser as onDeleteUser,
} from "store/contacts/actions";
import { isEmpty } from "lodash";

// redux
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";

const ContactsList = props => {
  const tableRef = useRef(null);
  document.title = "Kullanıcılar | DLAvia Admin Paneli";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();

  // --- DETAY MODAL STATE ---
  const [viewModal, setViewModal] = useState(false);
  const [viewContact, setViewContact] = useState(null);
  const [activeTab, setActiveTab] = useState("1");
  const [userStats, setUserStats] = useState({
    totalVoiceTime: "0 dk",
    generalAvg: 0,
    simulationAvg: 0,
    imageQuestionAvg: 0,
    lastActivity: "-"
  });

  const { users } = useSelector(state => ({
    users: state.contacts.users,
  }));

  const [modal, setModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // --- VERİ FETCH ---
  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetUsers());
    }
  }, [dispatch, users]);

  // --- YARDIMCI FONKSİYONLAR ---

  // Abonelik Bulucu
  const getLastSubscription = (user) => {
    if (!user?.User_Subscription || user.User_Subscription.length === 0) return null;
    const sortedSubs = [...user.User_Subscription].sort((a, b) => {
      return new Date(b.End_Date) - new Date(a.End_Date);
    });
    return sortedSubs[0];
  };

  // İstatistik Hesaplayıcı (JSON Yapısına Göre)
const calculateStats = (user) => {
    if (!user) return;

    // Ekran görüntüsündeki Users_Question_Report tablosunu baz alıyoruz
    const reports = user.Users_Question_Report || [];

    // 1. Toplam Ses Süresi (Timer_Time kolonuna göre)
    // DBeaver'da 15. kolon: Timer_Time
    const totalSeconds = reports.reduce((acc, report) => acc + (parseFloat(report.Timer_Time) || 0), 0);
    
    const duration = moment.duration(totalSeconds, 'seconds');
    const totalVoiceTimeFormatted = Math.floor(duration.asHours()) > 0 
        ? `${Math.floor(duration.asHours())} sa ${duration.minutes()} dk`
        : `${duration.minutes()} dk ${duration.seconds()} sn`;

    // 2. Son Aktivite (Created_DateTime kolonuna göre)
    let lastActivity = "-";
    if (reports.length > 0) {
        // En yeni raporu bul
        const sortedReports = [...reports].sort((a,b) => new Date(b.Created_DateTime) - new Date(a.Created_DateTime));
        lastActivity = moment(sortedReports[0].Created_DateTime).format("DD.MM.YYYY HH:mm");
    }

    // 3. Ortalamalar (Report_Type kolonuna göre filtreleme yapmalısın)
    const calcAvgByReportType = (typeStr) => {
        const filtered = reports.filter(r => r.Report_Type === typeStr);
        if (filtered.length === 0) return 0;
        const totalScore = filtered.reduce((acc, curr) => acc + (curr.Score || 0), 0);
        return Math.round(totalScore / filtered.length);
    };

    // Not: Report_Type değerlerinin veritabanında tam olarak nasıl yazıldığını kontrol et 
    // (Örn: "Simulation", "General", "Picture")
    const simAvg = calcAvgByReportType("Simulation"); 
    const genAvg = calcAvgByReportType("General");
    const imgAvg = calcAvgByReportType("Picture");

    setUserStats({
        totalVoiceTime: totalVoiceTimeFormatted,
        lastActivity: lastActivity,
        generalAvg: genAvg,
        simulationAvg: simAvg,
        imageQuestionAvg: imgAvg
    });
  };


  // --- MODAL İŞLEMLERİ ---
  const handleViewUser = (user) => {
      setViewContact(user);
      calculateStats(user);
      setActiveTab("1");
      setViewModal(true);
  };

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  // --- FORMIK ---
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: (contactEdit && contactEdit.Users_NameSurname) || "",
      tel: (contactEdit && contactEdit.PhoneNumber) || "",
      password: (contactEdit && contactEdit.Users_Password) || "",
      email: (contactEdit && contactEdit.EMail) || "",
    },
    validationSchema: Yup.object({
      username: Yup.string().min(3).required("Zorunlu"),
      email: Yup.string().email().required("Zorunlu"),
      password: Yup.string().min(6),
    }),
    onSubmit: values => {
      const now = moment().format('YYYY-MM-DD HH:mm:ss');
      if (isEdit) {
        dispatch(onUpdateUser({
          ID: contactEdit.ID,
          Users_NameSurname: values.username,
          PhoneNumber: values.tel,
          Users_Password: values.password,
          EMail: values.email,
          IsActive: true
        }));
      } else {
        dispatch(onAddUser({
          Users_NameSurname: values.username,
          PhoneNumber: values.tel,
          EMail: values.email,
          Users_Password: values.password,
          Created_DateTime: now,
          IsActive: true,
          DlaGoal: 0
        }));
      }
      setIsEdit(false);
      validation.resetForm();
      toggle();
    },
  });

  const toggle = () => setModal(!modal);
  const handleUserClick = (arg) => { setEditContact(arg); setIsEdit(true); toggle(); };
  const onClickDelete = (user) => { setContact(user); setDeleteModal(true); };
  const handleDeleteUser = () => { if (contact?.ID) dispatch(onDeleteUser(contact.ID)); setDeleteModal(false); };

  // --- KOLONLAR ---
  const columns = useMemo(() => [
      { Header: "#", Cell: () => <input type="checkbox" className="form-check-input" /> },
      // 1.b İsim
      { 
        Header: "Adı Soyadı", 
        accessor: "Users_NameSurname", 
        filterable: true, 
        Cell: cellProps => <span className="fw-bold">{cellProps.value}</span> 
      },
      // 1.a İletişim
      { 
        Header: "İletişim", 
        accessor: "EMail", 
        filterable: true,
        Cell: cell => (
            <div>
                <div><i className="mdi mdi-email me-1"></i> {cell.value}</div>
                <div className="text-muted"><i className="mdi mdi-phone me-1"></i> {cell.row.original.PhoneNumber}</div>
            </div>
        )
      },
      // 1.d Premium Durumu
      {
        Header: "Üyelik & Tarihler",
        accessor: "MembershipStatus",
        Cell: (cellProps) => {
          const lastSub = getLastSubscription(cellProps.row.original);
          const isActive = lastSub && lastSub.IsActive && new Date(lastSub.End_Date) > new Date();
          return (
            <div>
                <Badge color={isActive ? "success" : "secondary"} className="me-1">
                    {isActive ? "Premium" : "Free"}
                </Badge>
                {lastSub && (
                    <div className="font-size-11 text-muted mt-1">
                       Baş: {moment(lastSub.Start_Date).format('DD.MM.YY')} <br/>
                       Bit: {moment(lastSub.End_Date).format('DD.MM.YY')}
                    </div>
                )}
            </div>
          );
        }
      },
      // 1.c Kayıt Tarihi
      {
        Header: "Kayıt Tarihi",
        accessor: "Created_DateTime",
        Cell: cell => moment(cell.value).format('DD.MM.YYYY HH:mm')
      },
      {
        Header: "İşlemler",
        Cell: cellProps => (
            <div className="d-flex gap-2">
              <Button color="primary" size="sm" onClick={() => handleViewUser(cellProps.row.original)}>
                <i className="mdi mdi-eye"></i>
              </Button>
              <Button color="success" size="sm" onClick={() => handleUserClick(cellProps.row.original)}>
                <i className="mdi mdi-pencil"></i>
              </Button>
              <Button color="danger" size="sm" onClick={() => onClickDelete(cellProps.row.original)}>
                <i className="mdi mdi-delete"></i>
              </Button>
            </div>
        )
      },
    ], []
  );

  // --- PDF EXPORT (Mevcut Fonksiyon) ---
  const exportPDF = () => {
    const unit = "pt";
    const size = "A4"; 
    const orientation = "landscape"; 
    const doc = new jsPDF(orientation, unit, size);
    doc.setFontSize(15);
    doc.text("DLAvia Kullanıcı Listesi", 40, 40);
    const headers = [["Ad Soyad", "Email", "Telefon", "Üyelik", "Başlangıç", "Bitiş", "Kayıt Tar."]];
    const data = users.map(user => {
      const lastSub = getLastSubscription(user);
      const isPremium = lastSub && new Date(lastSub.End_Date) > new Date();
      return [
        user.Users_NameSurname || "-", user.EMail || "-", user.PhoneNumber || "-",
        isPremium ? "Premium" : "Free", 
        lastSub ? moment(lastSub.Start_Date).format('DD.MM.YYYY') : "-", 
        lastSub ? moment(lastSub.End_Date).format('DD.MM.YYYY') : "-",
        moment(user.Created_DateTime).format('DD.MM.YYYY')
      ];
    });
    doc.autoTable({ startY: 50, head: headers, body: data, theme: 'grid' });
    doc.save("DLAvia_Kullanicilar.pdf");
  };

  return (
    <React.Fragment>
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteUser} onCloseClick={() => setDeleteModal(false)} />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Kullanıcılar" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-end mb-3 gap-2">
                    <Button color="danger" className="btn-rounded" onClick={exportPDF}>
                        <i className="mdi mdi-file-pdf-box me-1"></i> PDF İndir
                    </Button>
                  </div>

                  <TableContainer
                    columns={columns}
                    data={users}
                    ref={tableRef}
                    isGlobalFilter={true}
                    customPageSize={10}
                  />

                  {/* --- KULLANICI DETAY MODALI --- */}
                  <Modal isOpen={viewModal} toggle={() => setViewModal(false)} size="lg" scrollable>
                    <ModalHeader toggle={() => setViewModal(false)}>
                        {viewContact?.Users_NameSurname} - Kullanıcı Analizi
                    </ModalHeader>
                    <ModalBody>
                        <Nav tabs className="nav-tabs-custom">
                            <NavItem><NavLink className={classnames({ active: activeTab === "1" })} onClick={() => toggleTab("1")}>İşlem & Aktivite</NavLink></NavItem>
                            <NavItem><NavLink className={classnames({ active: activeTab === "2" })} onClick={() => toggleTab("2")}>Gelişim & Performans</NavLink></NavItem>
                            <NavItem><NavLink className={classnames({ active: activeTab === "3" })} onClick={() => toggleTab("3")}>Simülasyon Raporları</NavLink></NavItem>
                        </Nav>

                        <TabContent activeTab={activeTab} className="p-3">
                            {/* TAB 1: Aktivite Bilgileri (2.a) */}
                            <TabPane tabId="1">
                                <Row className="mb-4">
                                    <Col md="6">
                                        <Card className="bg-light border-0">
                                            <CardBody>
                                                <h6 className="text-muted">Toplam Ses Kayıt Süresi</h6>
                                                <h3>{userStats.totalVoiceTime}</h3>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                    <Col md="6">
                                        <Card className="bg-light border-0">
                                            <CardBody>
                                                <h6 className="text-muted">Son Uygulama İşlemi</h6>
                                                <h3>{userStats.lastActivity}</h3>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                </Row>
                                <h6>Son Cevaplanan Sorular</h6>
                                <div className="table-responsive">
                                    <Table size="sm" striped>
                                        <thead><tr><th>Tarih</th><th>Tip</th><th>Süre</th><th>Skor</th></tr></thead>
                                        <tbody>
                                            {/* Users_Question verisi, ilişkisel olarak geldiyse */}
                                            {viewContact?.Users_Question?.slice(0, 5).map((q, i) => (
                                                <tr key={i}>
                                                    <td>{moment(q.Created_DateTime).format("DD.MM.YY HH:mm")}</td>
                                                    <td>
                                                        {q.Users_Question_Type === "PICTURE" ? <Badge color="info">Resim</Badge> : 
                                                         q.Users_Question_Type === "Simulation" ? <Badge color="warning">Simülasyon</Badge> : "Genel"}
                                                    </td>
                                                    <td>{q.Time_ ? `${q.Time_}s` : "-"}</td>
                                                    <td><Badge color={q.Score >= 70 ? "success" : "warning"}>{q.Score || "?"}</Badge></td>
                                                </tr>
                                            ))}
                                            {(!viewContact?.Users_Question || viewContact.Users_Question.length === 0) && (
                                                <tr><td colSpan="4" className="text-center">Kayıt bulunamadı.</td></tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </TabPane>

                            {/* TAB 2: Pratik Gelişim (2.b) */}
                            <TabPane tabId="2">
                                <Row>
                                    <Col md="4" className="text-center">
                                        <h5>Genel Pratik</h5>
                                        <div className="display-4 text-success">+{userStats.generalAvg}</div>
                                        <Progress value={userStats.generalAvg} color="success" className="mt-2" />
                                        <small className="text-muted">Ortalama Puan</small>
                                    </Col>
                                    <Col md="4" className="text-center">
                                        <h5>Resim Soruları</h5>
                                        <div className="display-4 text-info">+{userStats.imageQuestionAvg}</div>
                                        <Progress value={userStats.imageQuestionAvg} color="info" className="mt-2" />
                                        <small className="text-muted">Ortalama Puan</small>
                                    </Col>
                                    <Col md="4" className="text-center">
                                        <h5>Simülasyon</h5>
                                        <div className="display-4 text-warning">+{userStats.simulationAvg}</div>
                                        <Progress value={userStats.simulationAvg} color="warning" className="mt-2" />
                                        <small className="text-muted">Ortalama Puan</small>
                                    </Col>
                                </Row>
                            </TabPane>

                            {/* TAB 3: Simülasyon Raporları (2.c) */}
                            <TabPane tabId="3">
                                <Table striped bordered responsive>
                                    <thead>
                                        <tr>
                                            <th>Rapor No</th>
                                            <th>Tarih</th>
                                            <th>Genel Skor</th>
                                            <th>Detay (Akıcılık/Kelime/Gramer)</th>
                                            <th>Yorum</th>
                                        </tr>
                                    </thead>
                                  {/* Tab 3 içindeki Table gövdesini bu şekilde güncelle */}
<tbody>
    {viewContact?.Users_Question_Report?.sort((a,b) => new Date(b.Created_DateTime) - new Date(a.Created_DateTime)).map((report, k) => (
        <tr key={k}>
            <td>{report.Report_Number || "-"}</td>
            <td>{moment(report.Created_DateTime).format("DD.MM.YY HH:mm")}</td>
            <td>
                <Badge color={report.Score >= 70 ? "success" : "warning"} className="font-size-12">
                    {report.Score?.toFixed(1)}
                </Badge>
            </td>
            <td>
                <div className="font-size-11">
                    <div><span className="fw-bold">Akıcılık:</span> {report.Fluency_Score}</div>
                    <div><span className="fw-bold">Gramer:</span> {report.Grammar_Score}</div>
                    <div><span className="fw-bold">Telaffuz:</span> {report.Pronunciation_Score}</div>
                </div>
            </td>
            <td>
                <div style={{ maxWidth: "200px", fontSize: "11px" }}>
                    <strong>Süre:</strong> {report.Timer_Time} sn <br/>
                    <strong>Görev:</strong> {report.Task_Completion_Score}
                </div>
            </td>
        </tr>
    ))}
</tbody>
                                </Table>
                            </TabPane>
                        </TabContent>
                    </ModalBody>
                  </Modal>

                  {/* --- DÜZENLEME MODALI --- */}
                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle}>{isEdit ? "Düzenle" : "Ekle"}</ModalHeader>
                    <ModalBody>
                      <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }}>
                        <Row>
                            <Col xs={12}>
                                <div className="mb-3">
                                    <Label>İsim</Label>
                                    <Input name="username" onChange={validation.handleChange} value={validation.values.username} />
                                </div>
                                <div className="mb-3">
                                    <Label>Email</Label>
                                    <Input name="email" onChange={validation.handleChange} value={validation.values.email} />
                                </div>
                                <div className="mb-3">
                                    <Label>Telefon</Label>
                                    <Input name="tel" onChange={validation.handleChange} value={validation.values.tel} />
                                </div>
                                <div className="mb-3">
                                    <Label>Şifre</Label>
                                    <Input type={showPassword ? "text" : "password"} name="password" onChange={validation.handleChange} value={validation.values.password} />
                                </div>
                            </Col>
                        </Row>
                        <Button type="submit" color="success">Kaydet</Button>
                      </Form>
                    </ModalBody>
                  </Modal>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);